import React from "react";

import JiraLoginConfigForm from "../jira/JiraLoginConfigForm";
import { JiraSecurityToolLoginConfigProps } from "./JiraSecurityToolPropTypes";

function JiraSecurityToolConfiLoginForm({
  name,
  loginConfigList,
  ...props
}: {
  name: string;
  loginConfigList: JiraSecurityToolLoginConfigProps[];
}) {
  return (
    <JiraLoginConfigForm
      name={name}
      loginConfigList={loginConfigList}
      {...props}
      isSecurityTool={true}
    />
  );
}
export default JiraSecurityToolConfiLoginForm;
